<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="cls" :style="innerStyle" :stroke-width="strokeWidth" :stroke-linecap="strokeLinecap" :stroke-linejoin="strokeLinejoin" @click="onClick"><g clip-path="url(#clip0_748_46434)" stroke="transparent"><g clip-path="url(#clip1_748_46434)"><path d="M3.125 0h10l5 5v13.75c0 .69-.56 1.25-1.25 1.25H3.125c-.69 0-1.25-.56-1.25-1.25V1.25c0-.69.56-1.25 1.25-1.25Z" fill="#FF7D00"></path><path d="m5.05 14.493 1.822-2.678a.282.282 0 0 1 .433-.043l1.204 1.18 2.643-4.142a.283.283 0 0 1 .484.011l3.284 5.69a.285.285 0 0 1-.104.388.284.284 0 0 1-.142.037h-9.39a.283.283 0 0 1-.235-.443Z" fill="#FFF7F7"></path><path d="M5.596 8.429a1.429 1.429 0 1 0 2.857 0 1.429 1.429 0 0 0-2.857 0Z" fill="#fff"></path><path d="m13.125 0 5 5h-3.75c-.69 0-1.25-.56-1.25-1.25V0Z" fill="#FFCF8B"></path></g></g><defs><clipPath id="clip0_748_46434"><path fill="#fff" d="M0 0h20v20H0z"></path></clipPath><clipPath id="clip1_748_46434"><path fill="#fff" d="M0 0h20v20H0z"></path></clipPath></defs></svg>
</template>

<script lang="ts">
import { defineComponent, computed, CSSProperties } from 'vue';
import { getPrefixCls } from '../../_utils/global-config';
import { isNumber } from '../../_utils/is';

export default defineComponent({
  name: 'IconFileImageColor',
  props: {
    size: {
      type: [Number, String],
    },
    strokeWidth: {
      type: Number,
      default: 4
    },
    strokeLinecap: {
      type: String,
      default: 'butt',
      validator: (value: any) => {
        return ['butt', 'round', 'square'].includes(value);
      }
    },
    strokeLinejoin: {
      type: String,
      default: 'miter',
      validator: (value: any) => {
        return ['arcs', 'bevel', 'miter', 'miter-clip', 'round'].includes(value);
      }
    },
    rotate: Number,
    spin: Boolean
  },
  emits: {
    click: (ev: MouseEvent) => true,
  },
  setup(props, { emit }) {
    const prefixCls = getPrefixCls('icon');
    const cls = computed(() => [prefixCls, `${prefixCls}-file-image-color`, { [`${prefixCls}-spin`]: props.spin }]);
    const innerStyle = computed(() => {
      const styles: CSSProperties = {};
      if (props.size) {
        styles.fontSize = isNumber(props.size) ? `${props.size}px` : props.size;
      }
      if (props.rotate) {
        styles.transform = `rotate(${props.rotate}deg)`;
      }
      return styles;
    });
    const onClick = (ev: MouseEvent) => {
      emit('click', ev);
    };

    return {
      cls,
      innerStyle,
      onClick,
    };
  }
});
</script>
